import { useHMSMuteAllPeersAudio } from "../hms";
import { useLivekitMuteAllPeersAudio } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderMuteAllPeers = () =>
  useProviderHook({
    hms: useHMSMuteAllPeersAudio,
    livekit: useLivekitMuteAllPeersAudio,
  })();
